import React from 'react';

import './youtube-playlist.css';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import { IcoMoonIcon } from '@wwe-portal/ui/components/icons';

export const YoutubePlaylist = () => {
  /**
   * Use translation hook
   * @see https://react.i18next.com/
   */
  const t = useTranslations();

  return (
    <div className="youtube-playlist-item text-left">
      <div className="relative m-0">
        <div className="youtube-playlist-item-video-block">
          <iframe
            className="h-full w-full"
            title="WWEMusic"
            src="https://www.youtube.com/embed/videoseries?list=PLB7CJiNeHXFh2L9KzjNqW6sH0AofdeKfs"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; local-network-access"
            allowFullScreen
          />
        </div>
      </div>
      <div>
        <div className="ml-0 mt-5 flex items-center">
          <a
            href="https://www.youtube.com/playlist?list=PLB7CJiNeHXFh2L9KzjNqW6sH0AofdeKfs"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Image
              src="/assets/images/play-game/wwe-music.jpg"
              alt="youtube-playlist"
              className="rounded-full border-2 border-white"
              width={30}
              height={30}
            />
          </a>
          <div className="ml-4">
            <div className="text-text500 flex items-center">
              <a
                href="https://www.youtube.com/playlist?list=PLB7CJiNeHXFh2L9KzjNqW6sH0AofdeKfs"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className="text-text500 text-xs font-medium">
                  WWEMusic
                </span>
              </a>
              <IcoMoonIcon
                iconName="checkbox-rounded"
                className="text-text700 ml-1 h-[14px] w-[14px]"
              />
            </div>
            <span className="text-chetwodeBlue text-xs">
              1M {t('subscribers')}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
